import { RadioGroupOption } from "~/common/components";

export const PROVIDER_SCHEDULE_METHODS = {
  PHONE: "phone",
  EMAIL: "email",
  CALENDAR: "calendar",
} as const;

export const PHONE_SCHEDULE_VARIANTS = {
  VOICE_ONLY: "voice_only",
  TEXT_ONLY: "text_only",
  VOICE_AND_TEXT: "voice_and_text",
} as const;

export const phoneNumberModes: RadioGroupOption[] = [
  { label: "Voice only", value: PHONE_SCHEDULE_VARIANTS.VOICE_ONLY },
  { label: "Text only", value: PHONE_SCHEDULE_VARIANTS.TEXT_ONLY },
  { label: "Voice & text", value: PHONE_SCHEDULE_VARIANTS.VOICE_AND_TEXT },
];
